const projectEmployeeReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default projectEmployeeReducer;